const BottomRightBoxHighlight = ({ children, color }) => (
  <div className="absolute flex h-5 bottom-0 right-0 font-semibold">
    <div className="w-7 overflow-hidden inline-block">
      <div
        className={`h-10 ${
          color || 'background-theme'
        } rotate-45 transform origin-bottom-right`}
      ></div>
    </div>
    <div
      className={`inline-block ${
        color || 'background-theme'
      } text-theme text-xs uppercase italic px-2`}
      style={{ paddingTop: '2px' }}
    >
      {children}
    </div>
  </div>
);

export default BottomRightBoxHighlight;
